// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__0II_j","breadcrumb":"Breadcrumbs_breadcrumb__pq59J","active":"Breadcrumbs_active__bS54_","arrowIcon":"Breadcrumbs_arrowIcon__rIS_X"};